import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class DescribedByBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.describedBy = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let describedBy = ko.unwrap(value);

                if (!describedBy) {
                    return;
                }

                // Falls das Element noch keine ID besitzt, wird diese anhand des darüberliegenden Controls erzeugt
                if (!describedBy.attr('id')) {
                    let parentControl = describedBy.parents('.c-control').first();
                    describedBy.attr('id', parentControl.data('control') + '-description')
                }

                element.removeAttr('aria-describedby');
                element.attr('aria-describedby', describedBy.attr('id'));
            }
        };
    }
}